import { Component, OnInit, Inject, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InputControl } from '@vex/utils/input-control';
import { Icons } from '@vex/icons/icons';
import { HelperService } from '@vex/services/helper.service';
import { ToastrService } from 'ngx-toastr';
import { FieldMandatory} from '@vex/constants/settings';
import { UserService } from '@vex/http-service/user.service';
import { SingleSelectionComponent } from '@vex/components/vex-selection/single-selection/single-selection.component';
import { AiService } from '@vex/http-service/ai.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'elastic-kumobot-setting',
  templateUrl: './kumobot-setting.component.html',
  styleUrls: ['./kumobot-setting.component.scss']
})
export class KumobotSettings extends Icons implements OnInit,OnDestroy {
  disabledSaveButton: boolean = false;
  form: FormGroup;
  mode: 'Create' | 'Update' = 'Create';
  models: any[];
  usersAttribute: any = {
    IsMandatory: true,
    DisplayName: 'Model',
    loader: false,
    Name: 'Model'
  };
  toggleMode: string = '';
  @ViewChild('modelSelection', { static: false }) modelSelection:SingleSelectionComponent;
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public defaults: any,
    public dialogRef: MatDialogRef<KumobotSettings>,
    private inputControl: InputControl,
    private fb: FormBuilder,
    private ai: AiService,
    private toastrService: ToastrService,
    public helperService: HelperService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit() {
    this.getModels();
    let source: number = 1;
    this.form = this.fb.group({
      Model: [this.defaults?.model || '', Validators.required],
      KumoBotRole: [this.defaults?.role || '', Validators.required],
      SpecificInstructions: [this.defaults?.instructions || '', Validators.required]
    });
    if (this.defaults?.model) {
      this.modelSelection?.formCtrl?.setValue(this.defaults.model);
    }
    this.toggleMode = this.defaults?.toggleMode || 'Co-Pilot Mode'; 
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

   onToggleChange(event: MatSlideToggleChange) {
    this.toggleMode = event.checked ? 'Co-Pilot Mode' : 'Prompt-to-Blueprint';
  }

  getModels() {
    this.usersAttribute.loader = true;
    this.ai.getModels().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.usersAttribute.loader = false;
      this.models = data.map((item) => ({
        Label: item,
        Value: item,
        Disabled: false
      }));
      if (this.models.length > 0 && !this.form.get('Model').value) {
        const firstModel = this.models[0];
        this.modelSelection.formCtrl.setValue(firstModel.Value);
        this.form.get('Model').setValue(this.models[0].Value);
      }
      this.modelSelection.selectionValues = this.models;
    });
  }

  inputState(formControl, form, attr) {
    return this.inputControl.isErrorState(formControl.controls[attr], form);
  }

  save() {
    if (!this.form.valid) {
      this.toastrService.info(FieldMandatory);
      return;
    }
    this.disabledSaveButton = true;
    this.dialogRef.close({
      isSaved: true,
      toggleMode: this.toggleMode,
      data: this.form.getRawValue()
    });
  }

  close(){
    this.dialogRef.close({
      isSaved: false,
      data: this.form.getRawValue()
    });
  }
}
